import React, { useEffect, useState } from "react";
import "./Alerts.css";
import DateFilter from "../../components/DateFilter/DateFilter";
import moment from "moment";
import { fetchAlerts } from "../../app/slices/alertsSlice";
import { useDispatch, useSelector } from "react-redux";
import { oracleDateFormat } from "../../app/utils";
import ErrorContainer from "../../components/ErrorContainer/ErrorContainer";
import LoadingContainer from "../../components/LoadingContainer/LoadingContainer";
import EmptyDataContainer from "../../components/EmptyDataContainer/EmptyDataContainer";

const Alerts = () => {
  const {
    data: alertsList,
    status: statusAlerts,
    error: errorAlerts,
  } = useSelector(({ alerts }) => alerts.get);

  const [formValues, setFormValues] = useState({
    fromDate: moment().subtract(1, "years").format("YYYY-MM-DD"),
    toDate: moment().format("YYYY-MM-DD"),
    status: "A",
  });

  const dispatch = useDispatch();

  //use effects
  useEffect(() => {
    handleSubmit();
  }, []);

  //methods
  const handleSubmit = () => {
    dispatch(
      fetchAlerts({
        status: formValues?.status,
        start_date: formValues?.fromDate
          ? moment(formValues?.fromDate).format(oracleDateFormat)
          : null,
        end_date: formValues?.toDate
          ? moment(formValues?.toDate).format(oracleDateFormat)
          : null,
      })
    );
  };

  //builders
  const BuildListItem = ({ alert }) => {
    return (
      <a href={`/alerts/alert-details?id=${alert?.alert_id}`}>
        <div className="alert-item">
          <img
            src={`${process.env.REACT_APP_SERVER_URL}/uploads/alerts/${alert?.cover_image}`}
            alt=""
          />
          <div className="shader">
            <h3>{alert?.title}</h3>
            <small className="mt-5">
              {moment(alert?.published_date)?.format("DD-MMM-YYYY")}
            </small>
          </div>
        </div>
      </a>
    );
  };

  return (
    <div className="alerts app-padding">
      <DateFilter
        formValues={formValues}
        setFormValues={setFormValues}
        handleSubmit={handleSubmit}
      />
      <section className="mb-30">
        <div className="flex-row flex-wrap">
          {alertsList?.map((alert) => (
            <BuildListItem alert={alert} />
          ))}
        </div>

        {statusAlerts === "loading" && (
          <LoadingContainer message={"Loading please wait..."} />
        )}

        {alertsList?.length === 0 && statusAlerts === "idle" && (
          <EmptyDataContainer message={"Nothing found"} />
        )}

        {errorAlerts && statusAlerts !== "loading" && (
          <ErrorContainer
            message={errorAlerts?.message}
            onReload={() => {
              handleSubmit();
            }}
          />
        )}
      </section>
    </div>
  );
};

export default Alerts;
